export default {
    props:{
        placeholder:{
            type:String,
            default:'Select'
        },
        checkValue:{
            type:Array | String,
            default: ()=>{
                return[]
            }
        },
        clearable:{
            type:Boolean,
            default:true
        },
        searchParams:{
            type:Object,
            default: () =>{
                return{
                    page:1,
                    pageCount:1,
                    query:'',
                    timer:''
                }
            }
        },
        // 显示字段
        txt:{
            type:String,
            default:'name'
        },
        // 选项显示字段(可能选择展示的内容与下拉选项的内容不一样)
        optionTxt:{
            type:String,
            default:'optionTxt'
        },
        // 选择字段
        val:{
            type:String,
            default:'id'
        },
        optionList:{
            type:Array,
            default: () =>{
                return []
            }
        },
        refStr:{
            type:String,
            default:'refStr'
        },
        styleObj:{
            type:Object,
            default: () =>{
                return{}
            }
        },
        className:{
            type:String,
            default:''
        },
        labelInValue:{
            type:Boolean,
            default:false
        },
        multiple:{
            type:Boolean,
            default:false
        },
        maxTagCount:{
            type:Number,
            default:2
        },
        hasCusOption:{
            type:Boolean,
            default:false
        },
        slotLabel:{
          type:Boolean,
          default:false
        },
        // 下拉类型
        type:{
            type:String,
            default:'search-select'
        },
        disabled:{
            type:Boolean,
            default:false
        },
        optionMaxWidth:{
            type:String,
            default:''
        },
    },
    data () {
       return {
         isFocused:false,
         widthValue:'',
         isOpen:false,
       };
    },

    computed:{
        changeValue:{
            get(){
                return this.checkValue;
            },
            set(value){
                //核心部分
                this.$emit("update:checkValue",value)
            }
        }
    },

    mounted(){
        if(this.optionMaxWidth && this.optionMaxWidth === '100%'){
            this.widthValue = this.$refs[this.refStr].$el.clientWidth + 'px';
        }else if(this.optionMaxWidth && this.optionMaxWidth !== '100%'){
            this.widthValue = this.optionMaxWidth;
        }
    },

    methods: {
        // 回车搜索
        searchNow:function(){
            this.$refs[this.refStr].visible = true;
            clearTimeout(this.searchParams.timer);
            this.searchParams.page = 1;
            this.$parent.optionList = [];
            this.$emit('queryFun',this.searchParams);
        },
        // 滚动加载
        handScroll:function(data){
            this.$emit('queryFun',data);
        },
        // 搜索词改变查询
        changeQuery:function(value){
            let _this = this;
            console.log(_this.isFocused)
            if(_this.isFocused){
                this.searchParams.query = value;
                clearTimeout(this.searchParams.timer);
                this.searchParams.timer = setTimeout(function(){
                  _this.searchParams.page = 1;
                  _this.$parent.optionList = [];
                  _this.$emit('queryFun',_this.searchParams);
                },1000);
            }else{
                this.searchParams.query = null;
            }
        },
        // 切换选项（on-change触发）
        changeOption:function(data){
            let _this = this;
            this.$emit('changeOption',data || this.searchParams);
            _this.isFocused = false;
        },
        // 展开下拉列表
        openChangePanel:function(flag){
            let _this = this;
            this.isOpen = flag;
            _this.isFocused = flag;
            this.$emit('openChangeFun',flag);
        },
        // 自定义Option时选择
        checkOption:function(data){
            this.$emit('checkOption',data);
        }
    },
 }



// WEBPACK FOOTER //
// ./src/admin/components/commonComponents/scrollSelect.js